import React from 'react';
import { connect } from 'react-redux';
import Autosuggest from 'react-autosuggest';
import { myAutosuggestStyle } from './PicContactsAutosuggestStyle';
import axios from 'axios';
import getAppConfigParm  from '../config/AppConfig';
// import participants from '../fixtures/participants';
import { initializeContacts }  from '../actions/contacts';


/* ******************************************************* */
// This is first Autosuggest example.                      */ 
// Be default it renders an unordered list 
/* ******************************************************* */

// const desktopStyle = {
//   suggestionsContainerOpen:  {
//     display: 'block',
//     position: 'absolute',
//     top: '44',
//     width: '276',
//     border: '1px solid red',
//     backgroundColor: '#fff',
//     fontFamily: 'Helvetica, sans-serif',
//     fontWweight: 300,
//     fontSize: 12,
//     borderBottomLeftRadius: '4',
//     borderBottomRightRadius: '4',
//     marginLeft: 1,
//     marginTop: -16,
//     zIndex: 2
//   }
// }

// const mobileStyle = {
//   suggestionsContainerOpen:  {
//     display: 'block',
//     position: 'absolute',
//     top: '44',
//     width: '276',
//     border: '1px solid green',
//     backgroundColor: '#fff',
//     fontFamily: 'Helvetica, sans-serif',
//     fontWweight: 300,
//     fontSize: 12,
//     borderBottomLeftRadius: '4',
//     borderBottomRightRadius: '4',
//     marginLeft: 1,
//     marginTop: -16,
//     zIndex: 2
//   }
// }

// var style = function() {
//    if (window.innerWidth < 480) {
//      return mobileStyle;
//    } else {
//      return {};
//    }
// }

/*
    Child  Component: This is a child component;this component provides two input fields with autosuggest
                      capability. When user enters email or name, the component will match that against
                      user contacts list and auto suggest some values. User can select a sugested value,
                      or type in a completely new one.
    Parent Component: PicInvites ;  renders autosuggest input bar and participant table list.
                      PicInvites is utililizing this component to render its input bar (autosuggest component).
    inputs:  - email and name values provided by end user via autoSuggest input fields
             - list of user contacts (from local state) 
             - (function prop) the "setParentComponentValues" is passed down from the parent so this component
                can pass back the emailValue and nameValue selected/entered within this component, 
                to the parent for rendering.
    outputs: - a list of suggestions rendered via the drop down for user to select from.
 */
class PicContactsAutosuggest extends React.Component {
  constructor() {
    super();
 
    // Autosuggest is a controlled component.This means that you need to provide an input value
    // and an onChange handler that updates this value (see below). Suggestions also need to 
    // be provided to the Autosuggest,and they are initially empty because the Autosuggest is closed.
    this.state = {
      emailValue: '',           // both emailValue and nameValue is set when a suggestion is selected
      nameValue: '',            //      from either the email input field or name input field
      emailSuggestions:[],      // this is populated with array of email suggestions
      nameSuggestions: [],       // this is populated with array of name suggestions
      setChildFunction: false,
    };
  }

  
  // **********************************************************************************
  //  Below is a function pair for getEmailSuggestions and getNameSuggestions
  // **********************************************************************************
  // Teach Autosuggest how to calculate suggestions for any given input value.
  // input(s):  Value (email) entered in input field
  //            Contacts: used to filter thru contacts to suggest emails that match characters of input value
  // output(s): [] Empty array, if input value is empty spaces; array list of suggestions from matching emails.
  // Process:   step1: get length of input value
  //            step2: filter through contacts list checking if exact number of characters typed, match
  //                   exact number of characters for the email in the contact list.
  getEmailSuggestions = value => {
    let contacts = this.props.contacts.list; 
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;
    
    return inputLength === 0 ? [] : contacts.filter(contact => 
      contact.email.toLowerCase().slice(0, inputLength) === inputValue
    ).slice(0,6);
  };
  // Same process used as one above
  getNameSuggestions = value => {
    let contacts = this.props.contacts.list; 
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;
  
    return inputLength === 0 ? [] : contacts.filter(contact =>
      contact.name.toLowerCase().slice(0, inputLength) === inputValue
    ).slice(0,6);
  };

  // **********************************************************************************
  //  Below is a function pair for getEmailSuggestionValue and getNameSuggestionValue
  // **********************************************************************************
  // These are fired when user selects a suggestion (email or name). This uses the emailSuggestion Object
  // to set the state for the associated value. Then, as per Autosuggest contract, it returns the
  // the selected object. The selectecd object is passed via the Autosuggest prop.
  getEmailSuggestionValue = emailSuggestion => {
      this.setState({nameValue: emailSuggestion.name});  // update state with associated nameValue
      this.props.setParentComponentValues(emailSuggestion.email, emailSuggestion.name);
      return emailSuggestion.email;                      // return selection so Autosuggest can set state emailValue
  };
    
  getNameSuggestionValue = nameSuggestion  => {
    this.setState({emailValue: nameSuggestion.email}); // update state with associated emailValue
    this.props.setParentComponentValues(nameSuggestion.email, nameSuggestion.name);
    return nameSuggestion.name;                        // return selection so Autosuggest can set state of nameValue
  };

  // **********************************************************************************
  //  Below is function pair for onEmailChange and onNameChange
  // **********************************************************************************
  // When ever you type into email field, this will get fired and set state.emailValue.  
  // The newValue parm will have the characters entered
  onEmailChange = (event, { newValue }) => {
    let emailValue = newValue.trim();
    this.props.onChangeField1Handler(emailValue);
    // this.setState({
    //   emailValue
    // });
  };
  // When ever you type into name field, this will get fired and set state.nameValue.  
  // The newValue parm will have the characters entered
  onNameChange = (event, { newValue }) => {
    let nameValue = newValue;
    this.props.onChangeField2Handler(nameValue);
    // this.setState({
    //   nameValue: newValue
    // });
  };
 
  // **********************************************************************************
  //  Below is function pair for onEmailChange and onNameChange
  // **********************************************************************************
  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onEmailSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      emailSuggestions: this.getEmailSuggestions(value)
    });
  };
  onNameSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      nameSuggestions: this.getNameSuggestions(value)
    });
  };
 
  // **********************************************************************************
  //  Below is function pair for onEmailChange and onNameChange
  // **********************************************************************************
  // Autosuggest will call this function every time you need to clear suggestions.
  onEmailSuggestionsClearRequested = () => {
    this.setState({
      emailSuggestions: []
    });
  };
  onNameSuggestionsClearRequested = () => {
    this.setState({
      nameSuggestions: []
    });
  };

  // **********************************************************************************
  //  Below is function pair for rendering dropdown for email and name fields
  // **********************************************************************************
  // Render drop down suggestion list / Note suggestion is using autosuggest is rendering with
  // the style specified in react-autosuggest__suggestion
  renderEmailSuggestion = (suggestion) => (
    <span>
      {suggestion.email}  
    </span> 
  );
  renderNameSuggestion = (suggestion) => (
  <span>
      {suggestion.name}  
  </span> 
  );

  // **********************************************************************************
  //  Lifecycle methods
  // **********************************************************************************
 
  // The getChildFunction is passed down from the parent component via a function prop.
  // When we call, we are effectively providing a reference to clearInputFields() to the parent
  // The parent saves the reference in local state as childFunction. Everytime the parent
  // needs to clear the input fields of this component it calls the childFunction which is
  // mapped to clearInputFields() above. 
  // ComponentDidMount also initializes the user contacts list, so it can be searched by 
  // autosuggest for suggestions. 
  componentDidMount() {
      // call parents getChildFunction prop and pass it method used to clear input fields   
      // this.props.getChildFunction(this.clearInputFields);

      // Initialize user contacts
      this.getUserContacts();
      
  }
 
  // **********************************************************************************
  //  Specialty / helper functions
  // **********************************************************************************
 
  // This method is called by the parent (PicInvites). The parent calls this method to clear
  // the input fields when user clicks the plus icon to add new participant. The reference
  // to this method is provided to the parent via getChildFunction in the componentDidMount
  // Life cycle method.
  clearInputFields = (inputField) => {
    if (inputField === 'both') {
      this.setState({emailValue: '', nameValue: ''})
    } 
    if (inputField === 'name') {
      this.setState({nameValue: ''})
    }
  }

  // Purpose of this function is to address following problem:
  // Problem: When user selects a name from suggestion list dropdown, the getEmailSuggestionValue or
  // getNameSuggestionValue method is triggered,  which updates the parent component with the
  // selected values. Problem is when user does not select a suggested value from the list, 
  // and instead types in a new value, there is no event handler to let parent know what are 
  // the inputted values. The onBlur event was a way to handle this, as when you lose
  // focus from name field you can fire this handler. Same for email
  onHandleOnBlurOfNameField = () => {
    // if (this.state.emailValue && this.state.nameValue) {
      // this.props.setParentComponentValues(this.state.emailValue, this.state.nameValue);
      this.props.onChangeField1Handler(this.props.emailValue);
    // }
  }
  onHandleOnBlurOfEmailField = () => {
      // this.props.setParentComponentValues(this.state.emailValue, this.state.nameValue);
      this.props.onChangeField2Handler(this.props.nameValue);
  }

  getUserContacts = () => {
    let self = this;
      
    // Pull out x-auth token and user email will get pullled on server side was authenticated
    let userToken = this.props.auth.token;
      
            // Call GET /user/contacts and update redux store with contacts array
    /*Construct url for api call and set up header */
    let url    = getAppConfigParm("picUrl") + '/user/contacts'; 
    let header = getAppConfigParm("axiosConfig", userToken);
      
    /* Make api call to to get contacts */
    axios.get(url, header)
        .then(function (response) {
          let contactList = response.data.contacts || [];
          self.props.initializeContacts(contactList);
    }).catch ((error) => {  /* TBD - this error should be logged to database */
          console.log(`Error encountered while trying to retrieve Contacts in PicContactsAutosuggest component`);
          console.log(error);
    });
}


  // **********************************************************************************
  //  This is primary render method called by the React Component
  // **********************************************************************************
  render() 
  {
    const { emailSuggestions } = this.state;

    // Autosuggest will pass through all these props to the input.
    const emailInputProps = {
      placeholder: 'Enter email address',
      value: this.props.emailValue || '',
      onChange: this.onEmailChange,
      onBlur:  this.onHandleOnBlurOfEmailField,
      className: "invites-email-input"
    };
    const nameInputProps = {
      placeholder: 'Enter name',
      value: this.props.nameValue || '',
      onChange: this.onNameChange,
      onBlur: this.onHandleOnBlurOfNameField,
      className: "invites-name-input"
    };
 
    // Finally, render it!
    return (
      <div className="invites-autosuggest-col02-03">
          <Autosuggest 
            suggestions={emailSuggestions}                                        // array of objects
            onSuggestionsFetchRequested={this.onEmailSuggestionsFetchRequested}   // Called anytime you need to recalc suggestions
            onSuggestionsClearRequested={this.onEmailSuggestionsClearRequested}   // called everytime you need to clear out suggestions.
            getSuggestionValue={this.getEmailSuggestionValue}                     // code to extract selection value when clicked
            renderSuggestion={this.renderEmailSuggestion}                         // This is function used to render your suggestion
            inputProps={emailInputProps}                                          // Pass through props to the input. Note value and onChange are mandatory.
            // theme={myAutosuggestStyle('email')}                                   
          />  
          <div className="invites-autosuggest-spacer">&nbsp;</div>    
          <Autosuggest
            suggestions={this.state.nameSuggestions}                             // array of objects
            onSuggestionsFetchRequested={this.onNameSuggestionsFetchRequested}   // Called anytime you need to recalc suggestions
            onSuggestionsClearRequested={this.onNameSuggestionsClearRequested}   // called everytime you need to clear out suggestions.
            getSuggestionValue={this.getNameSuggestionValue}                     // code to extract selection value when clicked
            renderSuggestion={this.renderNameSuggestion}                         // This is function used to render your suggestion
            inputProps={nameInputProps}                                          // Pass through props to the input. Note value and onChange are mandatory.   
            theme={myAutosuggestStyle('name')}                                   
          />   
      </div>                                                              
    );
  } /* end of render method */

} /* end of class defintion */

const mapStateToProps = (state) => {
  return {
      auth:       state.auth,
      contacts:   state.contacts
  };
};

const mapDispatchToProps = (dispatch) => ({
  initializeContacts:     (contacts) => dispatch(initializeContacts(contacts))
});

export default connect(mapStateToProps, mapDispatchToProps)(PicContactsAutosuggest);



// WEBPACK FOOTER //
// ./src/components/PicContactsAutosuggest.js